import React from "react";
import Lottie from "lottie-react";
import animationData from "./LoadingAnimation.json"; 

export default function IsLoading() {
  return (
    <div className="fixed top-0 left-0 w-full h-screen flex flex-col justify-center items-center bg-white dark:bg-black z-50">
      <Lottie
        animationData={animationData}
        loop={true}
        className="w-40 h-40 md:w-52 md:h-52"
      />
      <h2 className="mt-4 text-lg md:text-xl font-semibold text-primary ">
        Loading, please wait...
      </h2>
    </div>
  );
}
